import React from "react";
import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { SITE, NAV } from "../lib/data";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-pkcharcoal text-white/70 pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
        <div className="md:col-span-5">
          <Link to="/" className="flex items-center gap-2">
            <Flame className="w-5 h-5 text-pkred" strokeWidth={1.5} />
            <span className="font-serif text-2xl tracking-[0.25em] text-white">
              {SITE.brand}
            </span>
          </Link>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-white/60">
            Vidéki élménybirtok a Tisza partján. Szabadtűzi gasztronómia,
            kemencés estek, vendégház és kézműves élmények egy helyen.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[0.65rem] tracking-[0.3em] uppercase text-pkred font-semibold mb-5">
            Menü
          </div>
          <ul className="space-y-3 text-sm">
            {NAV.map((n) => (
              <li key={n.href}>
                <Link
                  to={n.href}
                  className="hover:text-pkred transition-colors"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[0.65rem] tracking-[0.3em] uppercase text-pkred font-semibold mb-5">
            Elérhetőség
          </div>
          <ul className="space-y-3 text-sm">
            <li>{SITE.address}</li>
            <li>
              <a
                href={SITE.phoneHref}
                className="hover:text-pkred transition-colors"
              >
                {SITE.phone}
              </a>
            </li>
            <li>
              <a
                href={SITE.emailHref}
                className="hover:text-pkred transition-colors"
              >
                {SITE.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-white/40">
        <div>© {new Date().getFullYear()} Pakkaland · Minden jog fenntartva.</div>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/adatkezeles" className="hover:text-pkred transition-colors">
            Adatkezelési tájékoztató
          </Link>
          <Link to="/cookie" className="hover:text-pkred transition-colors">
            Cookie tájékoztató
          </Link>
          <span className="tracking-[0.25em] uppercase">
            Vezseny · Tisza-part
          </span>
        </div>
      </div>
    </footer>
  );
}
